import { render, staticRenderFns } from "./ad-advert.vue?vue&type=template&id=25137f86&scoped=true"
import script from "./ad-advert.vue?vue&type=script&lang=js"
export * from "./ad-advert.vue?vue&type=script&lang=js"
import style0 from "./ad-advert.vue?vue&type=style&index=0&id=25137f86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25137f86",
  null
  
)

export default component.exports